"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settings.systemCommunicationLabel': 'Comunicazione di sistema',
    'whatsapp.settings.systemCommunicationHint': 'Se abilitato, questo bot verrà utilizzato come canale di comunicazione predefinito del sistema. Solo un bot può ricoprire questo ruolo alla volta.',
    'whatsapp.settings.systemCommunicationGroupLabel': 'Gruppo per comunicazioni da bot ad admin',
    'whatsapp.settings.systemCommunicationGroupHint': 'Seleziona il gruppo che il bot utilizzerà per inviare messaggi di sistema agli amministratori. Utilizzato quando la comunicazione di sistema è abilitata.',
    'whatsapp.settings.selectGroup': 'Seleziona gruppo',
    'whatsapp.settings.title': 'Comunicazioni',
    'whatsapp.settings.description': 'Connetti e gestisci il tuo account WhatsApp tramite accesso con codice QR.',
    'whatsapp.settings.status': 'Stato connessione',
    'whatsapp.settings.statusConnected': 'Connesso',
    'whatsapp.settings.statusDisconnected': 'Disconnesso',
    'whatsapp.settings.entityLabel': 'ID Entità',
    'whatsapp.settings.logout': 'Disconnetti',
    'whatsapp.settings.entityIdLabel': 'ID Entità (numero di telefono o identificatore)',
    'whatsapp.settings.entityIdPlaceholder': 'Inserisci numero di telefono o ID entità',
    'whatsapp.settings.startLogin': 'Avvia accesso',
    'whatsapp.settings.qrTitle': 'Codice QR',
    'whatsapp.settings.qrInstruction': 'Apri WhatsApp sul telefono > Impostazioni > Dispositivi collegati > Collega un dispositivo > Scansiona questo codice QR.',
    'whatsapp.settings.logsTitle': 'Log di connessione',
    'whatsapp.settings.clearLogs': 'Cancella',
    'whatsapp.settings.noLogs': 'Nessun log ancora. Avvia un processo di accesso per vedere i log di connessione.',
    'whatsapp.settings.noSettings': 'Nessuna configurazione del numero di telefono disponibile. Creane una per iniziare.',
    'whatsapp.settings.creator': 'Creato da',
    'whatsapp.settings.pinMessageLabel': 'Messaggio fissato',
    'whatsapp.settings.pinMessagePlaceholder': 'Contenuto del messaggio da fissare nella conversazione',
    'whatsapp.settings.pinMessageHint': 'Se compilato, questo messaggio verrà fissato per questo numero.',
    'whatsapp.settings.pingerLabel': 'Pinger',
    'whatsapp.settings.pingerHint': 'Se abilitato, questo bot invia periodicamente messaggi ping per mantenere attiva la connessione.',
    'whatsapp.settings.phoneTitle': 'Impostazioni numero di telefono',
    'whatsapp.settings.formTitle': 'Configurazione WhatsApp',
    'whatsapp.settings.phoneLabel': 'Numero di telefono',
    'whatsapp.settings.titleLabel': 'Titolo',
    'whatsapp.settings.titlePlaceholder': 'es. Account principale, Linea supporto...',
    'whatsapp.settings.phonePlaceholder': 'Inserisci numero di telefono (es. +39123456789)',
    'whatsapp.settings.phoneHint': 'Inserisci il numero di telefono registrato su WhatsApp, incluso il prefisso internazionale.',
    'whatsapp.settings.reportEmailLabel': 'Email report',
    'whatsapp.settings.reportEmailPlaceholder': 'Aggiungi indirizzi email per i report riassuntivi',
    'whatsapp.settings.reportEmailHint': 'I riassunti delle conversazioni di gruppo verranno inviati a questi indirizzi email. Premi Invio per aggiungere ogni email.',
    'whatsapp.settings.languageLabel': 'Lingua del bot',
    'whatsapp.settings.languageHint': 'Lingua utilizzata dal bot per rispondere ai messaggi e generare riassunti.',
    'whatsapp.settings.communicationTypeLabel': 'Tipo di comunicazione',
    'whatsapp.settings.communicationTypeHint': 'Seleziona il canale di comunicazione utilizzato da questo bot.',
    'whatsapp.settings.communicationType.wa': 'WhatsApp',
    'whatsapp.settings.communicationType.tele': 'Telegram',
    'whatsapp.settings.apiIdLabel': 'ID API Telegram',
    'whatsapp.settings.apiIdPlaceholder': 'Inserisci ID API Telegram',
    'whatsapp.settings.apiIdHint': 'ID API numerico ottenuto da my.telegram.org.',
    'whatsapp.settings.apiHashLabel': 'Hash API Telegram',
    'whatsapp.settings.apiHashPlaceholder': 'Inserisci hash API Telegram',
    'whatsapp.settings.apiHashHint': 'Stringa hash API ottenuta da my.telegram.org.',
    'whatsapp.settings.telegramApiLink': 'Ottieni ID API e Hash per account Telegram',
    'whatsapp.settings.telegramAuthTitle': 'Autenticazione Telegram',
    'whatsapp.settings.telegramCodeInstruction': 'Inserisci il codice di verifica inviato al tuo account Telegram.',
    'whatsapp.settings.telegramCodePlaceholder': 'Codice',
    'whatsapp.settings.telegramCodeSubmit': 'Invia codice',
    'whatsapp.settings.telegramPasswordInstruction': 'Inserisci la password di autenticazione a due fattori del tuo account Telegram.',
    'whatsapp.settings.telegramPasswordPlaceholder': 'Password',
    'whatsapp.settings.telegramPasswordSubmit': 'Invia password',
    'whatsapp.settings.botResponseConditionLabel': 'Condizione di risposta del bot',
    'whatsapp.settings.botResponseConditionPlaceholder': 'Descrivi quando il bot deve rispondere, es. "Domande su orari di apertura, prezzi o servizi"',
    'whatsapp.settings.botResponseConditionHint': 'Il bot risponderà ai messaggi degli utenti che corrispondono a questa condizione. Lascia vuoto per disattivare le risposte automatiche.',
    'whatsapp.settings.avatarLabel': 'Avatar',
    'whatsapp.settings.selectAvatar': '-- Seleziona avatar --',
    'whatsapp.settings.avatarHint': 'Seleziona un avatar per le risposte AI su questo numero WhatsApp.',
    'whatsapp.settings.save': 'Salva impostazioni',
    'whatsapp.settings.startAgent': 'Avvia agente',
    'whatsapp.settings.stopAgent': 'Ferma agente',
    'whatsapp.settings.agentRunning': 'Agente in esecuzione',
    'whatsapp.settings.agentInitializing': 'Inizializzazione...',
    'whatsapp.settings.agent_status_active': 'Attivo',
    'whatsapp.settings.agent_status_initializing': 'Inizializzazione',
    'whatsapp.settings.agent_status_inactive': 'Inattivo',
    'whatsapp.settings.pop3.title': 'Server di report email',
    'whatsapp.settings.pop3.description': 'Configura server di report email per il recupero e il monitoraggio delle email.',
    'whatsapp.settings.pop3.add': 'Aggiungi server',
    'whatsapp.settings.pop3.empty': 'Nessun server di report email configurato. Clicca "Aggiungi server" per crearne uno.',
    'whatsapp.settings.pop3.untitled': 'Server senza titolo',
    'whatsapp.settings.pop3.host.label': 'Host del server',
    'whatsapp.settings.pop3.host.placeholder': 'pop.example.com',
    'whatsapp.settings.pop3.port.label': 'Porta',
    'whatsapp.settings.pop3.port.placeholder': '995',
    'whatsapp.settings.pop3.username.label': 'Nome utente',
    'whatsapp.settings.pop3.username.placeholder': 'Inserisci email o nome utente',
    'whatsapp.settings.pop3.password.label': 'Password',
    'whatsapp.settings.pop3.password.placeholder': 'Inserisci password',
    'whatsapp.settings.pop3.useTls.label': 'Usa TLS/SSL',
    'whatsapp.settings.pop3.enabled.label': 'Abilitato',
    'whatsapp.settings.pop3.save': 'Salva impostazioni report email',
    'whatsapp.settings.pop3.configure': 'Configura email',
    'whatsapp.settings.pop3.enabled.yes': 'Abilitato',
    'whatsapp.settings.pop3.enabled.no': 'Disabilitato',
    'whatsapp.settings.pop3.actions': 'Azioni',
    'whatsapp.settings.pop3.remove': 'Rimuovi',
    'whatsapp.settings.pop3.remove.failed': 'Impossibile rimuovere l\'account email.',
    'whatsapp.settings.pop3.remove.confirm': 'Sei sicuro di voler rimuovere questo account email?',
    'whatsapp.settings.pop3.removed': 'Account email rimosso con successo.',
    'whatsapp.settings.pop3.saved': 'Impostazioni email salvate con successo.',
    'whatsapp.settings.pop3.host.required': 'L\'host del server è obbligatorio.',
    'whatsapp.settings.pop3.isGmail.label': 'Gmail',
    'whatsapp.settings.pop3.isGmail.hint': 'Abilita per connettere il tuo account Gmail tramite OAuth.',
    'whatsapp.settings.pop3.gmail.info': 'Clicca "Connetti Gmail" per autorizzare l\'accesso alla lettura delle email.',
    'whatsapp.settings.pop3.gmail.connect': 'Connetti Gmail',
    'whatsapp.settings.pop3.gmail.connecting': 'Connessione in corso...',
    'whatsapp.settings.pop3.gmail.connected': 'Gmail connesso',
    'whatsapp.settings.pop3.gmail.notConnected': 'Gmail non connesso',
    'whatsapp.settings.pop3.gmail.disconnect': 'Disconnetti Gmail',
    'whatsapp.settings.pop3.gmail.authSuccess': 'Gmail connesso con successo.',
    'whatsapp.settings.pop3.gmail.authFailed': 'Impossibile connettere Gmail.',
    'whatsapp.settings.pop3.gmail.disconnectSuccess': 'Gmail disconnesso con successo.',
    'whatsapp.settings.pop3.gmail.disconnectFailed': 'Impossibile disconnettere Gmail.',
};
